import "./tasksWorkspace.css";
import React, { useEffect, useState, useCallback } from "react";
import { useSearchParams } from "react-router-dom";

// estilos
import "./taskNewMobile.css";
import "../../assets/style/componentPrincipal.css";
import moment from "moment";

import { Tasks } from "../../models/tasks";
import { DialogFormTask } from "./DialogFormTask";
import { TasksModeListGeneral } from "./new/TasksModeListGeneral";
import { NewDateFilters } from "./new/NewDateFilters";
import { DialogDetailItemsFlow } from "../pptos/form/flows/DialogDetailItemsFlow";
import { Model } from "../../models/model";

export const TasksListNew = () => {
  const [tasksList, setTasksList] = useState([]);
  // const [initialStateTask, setInitialStateTask] = useState({})

  const [openDialogFormTask, setOpenDialogFormTask] = useState(false);
  const [openDialogProjections, setOpenDialogProjections] = useState(false);

  const [idSelected, setIdSelected] = useState(0);
  const [currentTasks, setCurrentTasks] = useState({});
  const [infoItemPpto, setInfoItemPpto] = useState({});

  const [searchParams] = useSearchParams();
  const from = searchParams.get("from");
  const status = searchParams.get("status");
  const time = searchParams.get("time");
  console.log("from--", from, status, time);

  const [filters, setFilters] = useState({
    text: "",
    id_ppto: null,
    view: "list",
    id_responsable: 0,
    estado: "en proceso",
    time: time || "today",
    programacion: "",
    page: 1,
    rows: 20,
  });

  const getAll = useCallback(async () => {
    const params = new URLSearchParams(filters).toString();

    console.log("params enviados:", params);

    const resultsTasks = await Model.getAll({
      url: `tasks/all/general/?${params}`,
    });
    setTasksList(resultsTasks);
  }, [filters]);

  const handleChangeDate = (newValue, targetName) => {
    setFilters({
      ...filters,
      [targetName]: moment(newValue).format("YYYY-MM-DD"),
      page: 1,
    });
  };

  const handleFilters = async ({ target }) => {
    setFilters({
      ...filters,
      page: 1,
      [target.name]: target.value,
    });
  };

  const handleOpenEdit = async (taskId) => {
    setIdSelected(taskId);
    setOpenDialogFormTask(true);
  };

  const handleOpenEditFlow = async (itemTask) => {
    // console.log({ itemTask })

    let itemPptoId = itemTask?.info_flow?.id_item_ppto || null;
    setCurrentTasks(itemTask);

    if (itemPptoId) {
      const resultOneItemPpto = await Model.getOne({
        url: `budgets-items/${itemPptoId}`,
      });

      setInfoItemPpto(resultOneItemPpto);
    } else {
      let hitoId = 0;

      if (itemTask.tipo === "hito") {
        hitoId = itemTask.id;
      }

      if (itemTask.tipo === "task" || itemTask.tipo === "subtask") {
        hitoId = itemTask.id_hito;
      }

      const hitos = tasksList;
      for (let h = 0; h < hitos.length; h++) {
        if (hitos[h].id === hitoId) {
          itemPptoId = hitos[h]?.info_flow?.id_item_ppto || null;

          if (itemPptoId) {
            break;
          }

          // sino busco en tareas
          const tasks = hitos[h].subs;
          for (let t = 0; t < tasks.length; t++) {
            itemPptoId = tasks[t]?.info_flow?.id_item_ppto || null;

            if (itemPptoId) {
              break;
            }

            // sino busco en subtareas
            const subTareas = tasks[t].subs;
            for (let st = 0; st < subTareas.length; st++) {
              itemPptoId = subTareas[st]?.info_flow?.id_item_ppto || null;

              if (itemPptoId) {
                break;
              }
            }
          }
        }
      }

      if (itemPptoId) {
        const resultOneItemPpto = await Model.getOne({
          url: `budgets-items/${itemPptoId}`,
        });

        setInfoItemPpto(resultOneItemPpto);
      } else {
        setInfoItemPpto({
          id: null,
          id_presupuesto: itemTask?.id_proyecto || null,
        });
      }
    }

    setOpenDialogProjections(true);
  };

  const handleCheckDone = async (taskId) => {
    let newInfoTask = null;

    const newListUpdated = tasksList.map((it) => {
      if (it.id === taskId) {
        newInfoTask = {
          ...it,
          estado: it.estado === "completado" ? "por hacer" : "completado",
        };

        return newInfoTask;
      }

      return it;
    });

    setTasksList(newListUpdated);

    if (newInfoTask) {
      const newBody = {
        ...newInfoTask,
        change_state: true,
      };

      console.log({ newInfoTask });
      await Tasks.update(newBody);
    }
  };

  /* useEffect(() => {
        getAll()
    }, [getAll]) */

  useEffect(() => {
    const timer = setTimeout(() => {
      getAll();
    }, 500);

    return () => clearTimeout(timer);
  }, [filters, getAll]);

  return (
    <div className="p-container tasks-workspace">
      <TasksModeListGeneral
        dateFilters={
          <NewDateFilters compact filters={filters} setFilters={setFilters} handleChangeDate={handleChangeDate} />
        }
        setTasksList={setTasksList}
        tasksList={tasksList}
        filters={filters}
        handleFilters={handleFilters}
        opens={{
          handleOpenEdit: handleOpenEdit,
          handleOpenEditFlow: handleOpenEditFlow,
        }}
        origen={{
          from: "general",
          id: null,
        }}
        handleCheckDone={handleCheckDone}
      />

      {openDialogFormTask ? (
        <DialogFormTask
          open={openDialogFormTask}
          setOpen={setOpenDialogFormTask}
          taskId={idSelected}
          refreshObj={{
            fn_: getAll,
            filters_: filters,
          }}
        />
      ) : (
        ""
      )}

      {openDialogProjections ? (
        <DialogDetailItemsFlow
          open={openDialogProjections}
          setOpen={setOpenDialogProjections}
          item={infoItemPpto}
          tasksList={tasksList}
          currentTasks={currentTasks}
          refreshObj={{
            fn_: getAll,
            filters_: filters,
          }}
        />
      ) : (
        ""
      )}
    </div>
  );
};
